import { render, staticRenderFns } from "./TestimonialsListItem.vue?vue&type=template&id=4f2b9e83&scoped=true&"
import script from "./TestimonialsListItem.vue?vue&type=script&lang=js&"
export * from "./TestimonialsListItem.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsListItem.vue?vue&type=style&index=0&id=4f2b9e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b9e83",
  null
  
)

export default component.exports